// Банківські рахунки контрагента: український IBAN (UA + 2 контрольні + 6 МФО банку + 19 номер рахунку),
// контрольне число за ISO 13616 (mod 97). Валюта — код ISO 4217; один основний рахунок на валюту.

export const CURRENCIES = ["UAH", "USD", "EUR", "PLN", "GBP", "CHF"];

// «ua 12 3052 99…» → «UA123052…»
export const normalizeIban = (s) => String(s || "").replace(/[\s-]/g, "").toUpperCase();

// Помилка IBAN зрозумілою фразою або null
export function ibanError(raw) {
  const iban = normalizeIban(raw);
  if (!iban) return "Вкажіть IBAN";
  if (!/^UA/.test(iban)) return "IBAN українського банку починається з UA";
  if (!/^UA\d{27}$/.test(iban)) return `IBAN — UA і 27 цифр (зараз цифр: ${iban.slice(2).replace(/\D/g, "").length})`;
  const digits = (iban.slice(4) + iban.slice(0, 4)).replace(/[A-Z]/g, (ch) => String(ch.charCodeAt(0) - 55));
  let rest = 0;
  for (const d of digits) rest = (rest * 10 + Number(d)) % 97;
  return rest === 1 ? null : "Контрольні цифри IBAN не збігаються — перевірте, чи немає описки";
}

// МФО банку з IBAN (цифри 5–10)
export const mfoOf = (iban) => (/^UA\d{27}$/.test(iban) ? iban.slice(4, 10) : "");

// «UA21 3223 1300 0002 6007 2335 6600 1» — для показу й копіювання
export const ibanGroups = (iban) => normalizeIban(iban).replace(/(.{4})(?=.)/g, "$1 ");

// Рахунок для документів у гривні: основний у UAH, інакше найсвіжіший у UAH
export function documentAccount(accounts = []) {
  const uah = accounts.filter((a) => a.currency === "UAH");
  return uah.find((a) => a.isMain) || uah[0] || null;
}
